const NAMED = {
  all: "all",
  xsmn: "all",
  cn: 0,
  chunhat: 0,
  sun: 0,
  sunday: 0,
  t2: 1,
  thu2: 1,
  mon: 1,
  monday: 1,
  t3: 2,
  thu3: 2,
  tue: 2,
  tuesday: 2,
  t4: 3,
  thu4: 3,
  wed: 3,
  wednesday: 3,
  t5: 4,
  thu5: 4,
  thu: 4,
  thursday: 4,
  t6: 5,
  thu6: 5,
  fri: 5,
  friday: 5,
  t7: 6,
  thu7: 6,
  sat: 6,
  saturday: 6,
};

export function resolveConfigDow(value) {
  if (value === 0 || value === "0") return 0;
  if (value == null || value === false || value === "") return "all";
  const raw = String(value).trim().toLowerCase();
  if (!raw || raw === "all") return "all";
  const compact = raw.replace(/[\s_-]+/g, "");
  if (Object.prototype.hasOwnProperty.call(NAMED, compact)) return NAMED[compact];
  if (/^[1-6]$/.test(compact)) return Number(compact);
  if (compact === "7") return 6;
  return "all";
}

export function seriesDates(anchor, dow, count, dayOf) {
  const out = [];
  if (dow === "all") {
    for (let i = 0; i < count; i += 1) out.push(shift(anchor, i));
    return out;
  }
  let cursor = anchor;
  let guard = 0;
  while (dayOf(cursor) !== dow && guard < 7) {
    cursor = shift(cursor, 1);
    guard += 1;
  }
  for (let i = 0; i < count; i += 1) out.push(shift(cursor, i * 7));
  return out;
}

function shift(key, days) {
  const [year, month, day] = key.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() - days);
  return date.toISOString().slice(0, 10);
}
